const SuccessAlert = ({ text }) => {
    return <p className="successAlert py-2 mt-3 mb-0">{text}</p>
}

export default SuccessAlert;